import { styled } from '@superset-ui/core';
import React from 'react';


interface Props {
    buttonText: string;
    text?: string;
    // thumbnail?: string;
    handleClick?: () => any;
}

const StyledDiv = styled.div`
display: flex;
// height: 100%;
.view-more-card {
    border: 1px solid #D6DEEB;
    border-radius: 8px;
    padding: 1.25rem;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: .6em;
    width: 16rem;
    cursor: pointer;
}

.view-more-text {
    font-weight: 400;
    font-size: .8rem;
    line-height: .9rem;
    color: #A7A9BC;
}

.view-more-btn {
    color: #FFFFFF;
    padding: .5rem 1rem;
    background: #0046D9;
    border-radius: 4px;
}`;

const Card = (props: Props) => {
    return (
        <StyledDiv>
            <div className='view-more-card'>
                {/* { props.thumbnail && (<img src={props.thumbnail} alt="" />)} */}
                { props.text && (
                    <div className='view-more-text'>
                        {props.text}
                    </div>
                )}
                <div className='view-more-btn' onClick={props.handleClick}>
                    {props.buttonText}
                </div>
            </div>
        </StyledDiv>
    );
};

export default Card;